import React from "react";
import { useNavigate } from "react-router-dom";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";

type Props = {
  columns: columnTypes[];
  rows: any[];
  isTableLoading: boolean;
  noOfDays: number;
  setNoOfDays: (value: number) => void;
  dateRange: string;
};

const FollowupsListing = ({
  columns,
  rows,
  isTableLoading,
  noOfDays,
  setNoOfDays,
  dateRange,
}: Props) => {
  const navigate = useNavigate();

  const handleNoOfDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value)) {
      setNoOfDays(Math.max(0, value)); // Minimum 0 days (today only)
    }
  };

  return (
    <div className="flex flex-col gap-4">
      {/* Header Section */}
      <div className="p-4 bg-white rounded-lg shadow">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-700">
              Upcoming followups
            </h2>
            <p className="text-[13px] text-gray-500 mt-1">
              Showing data {noOfDays === 0 ? "for today" : "from today to"}{" "}
              <span className="font-medium">{dateRange}</span>
            </p>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <label
                htmlFor="noOfDays"
                className="text-sm font-medium text-gray-700"
              >
                {noOfDays === 0 ? "Today only" : "Days ahead:"}
              </label>
              {noOfDays === 0 ? (
                <button
                  onClick={() => setNoOfDays(1)}
                  className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded-md hover:bg-blue-200"
                >
                  + Add days
                </button>
              ) : (
                <input
                  type="number"
                  id="noOfDays"
                  min="0"
                  value={noOfDays}
                  onChange={handleNoOfDaysChange}
                  className="w-20 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="flex-1 overflow-auto bg-white rounded-lg shadow">
        <ATMTable
          columns={columns}
          rows={rows}
          onRowClick={(row) => navigate(`/future-purchase/${row?._id}/notes`)}
          isLoading={isTableLoading}
        />
      </div>
    </div>
  );
};

export default FollowupsListing;
